module.exports = __webpack_public_path__ + "img/0Q3A3001_L_Foamcore_MockedUp.5231c8b7.jpg";